const StorageKeys = {
    urlAdvisees: 'urlAdvisees',
    urlChecklist: 'urlChecklist',
    urlDegreeReq: 'urlDegreeReq'
};
export default StorageKeys;
